import script from "./wjadd.vue?vue&type=script&setup=true&lang=js"
export * from "./wjadd.vue?vue&type=script&setup=true&lang=js"

import "./wjadd.vue?vue&type=style&index=0&id=a44984ce&lang=scss&scoped=true"
import "./wjadd.vue?vue&type=style&index=1&id=a44984ce&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a44984ce"]])

export default __exports__